import React from "react";
import { CircularProgress, makeStyles } from "@material-ui/core";

const useStyles = makeStyles(
  () => ({
    roundCircle: { strokeLinecap: "round" },
    valueCircle: {
      position: "absolute",
      left: 0
    },
    backgroundCircle: {
      color: "rgba(0, 0, 0, 0.3)"
    }
  }),
  { name: "ProgressCircle" }
);

export function ProgressCircle(props) {
  const { value = 50 } = props;
  const classes = useStyles();
  return (
    <div>
      <CircularProgress classes={{ circle: classes.backgroundCircle }} size={50} value={100} variant={"determinate"} />
      <CircularProgress
        classes={{ circle: classes.roundCircle, root: classes.valueCircle }}
        size={50}
        value={value}
        variant={"determinate"}
      />
    </div>
  );
}
